/* unplugin-vue-components disabled */import { render } from "./w-slider.vue?vue&type=template&id=501c6cba&ts=true"
import script from "./w-slider.vue?vue&type=script&lang=ts"
export * from "./w-slider.vue?vue&type=script&lang=ts"

import "./w-slider.vue?vue&type=style&index=0&id=501c6cba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__